var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.6667C10 10.2985 10.2985 10 10.6667 10H12C12.3682 10 12.6667 10.2985 12.6667 10.6667V14H14C14.3682 14 14.6667 14.2985 14.6667 14.6667C14.6667 15.0349 14.3682 15.3333 14 15.3333H10C9.63181 15.3333 9.33333 15.0349 9.33333 14.6667C9.33333 14.2985 9.63181 14 10 14H11.3333V11.3333H10.6667C10.2985 11.3333 10 11.0349 10 10.6667Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 9.33333C12.219 9.33333 12.6667 8.88562 12.6667 8.33333C12.6667 7.78105 12.219 7.33333 11.6667 7.33333C11.1144 7.33333 10.6667 7.78105 10.6667 8.33333C10.6667 8.88562 11.1144 9.33333 11.6667 9.33333Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 5.33333C8.3181 5.33333 5.33333 8.3181 5.33333 12C5.33333 15.6819 8.3181 18.6667 12 18.6667C15.6819 18.6667 18.6667 15.6819 18.6667 12C18.6667 8.3181 15.6819 5.33333 12 5.33333Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.df713eeedab8972182cb2aa98389d5b4.svg";
export { ForwardRef as ReactComponent };